import React from "react";

import { StyledSVG } from "../StyledIcon";

export const EnterpriseIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <mask id="path-1-inside-1_2142_41135" fill="white">
        <rect x="1.19922" y="5.7002" width="9.9" height="11.1" rx="1" />
      </mask>
      <rect
        x="1.19922"
        y="5.7002"
        width="9.9"
        height="11.1"
        rx="1"
        stroke={iconColor}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#path-1-inside-1_2142_41135)"
      />
      <mask id="path-2-inside-2_2142_41135" fill="white">
        <rect x="6.89844" y="1.2002" width="9.9" height="15.6" rx="1" />
      </mask>
      <rect
        x="6.89844"
        y="1.2002"
        width="9.9"
        height="15.6"
        rx="1"
        stroke={iconColor}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#path-2-inside-2_2142_41135)"
      />
    </StyledSVG>
  );
};
